import { toast } from "react-hot-toast";

const defaultToastOptions = {
  duration: 3000,
};

const mapPosition = (position) => {
  if (position === "bottom-left") return "bottom-left";
  if (position === "bottom-right") return "bottom-right";
  if (position === "top-left") return "top-left";
  if (position === "top-right") return "top-right";

  return "top-right";
};

const withOptions = (options = {}) => ({
  ...defaultToastOptions,
  ...options,
  position: mapPosition(options.position),
});

const appToast = {
  success(message, options) {
    toast.success(message, withOptions(options));
  },
  error(message, options) {
    toast.error(message, withOptions(options));
  },
  info(message, options) {
    toast(message, withOptions(options));
  },
  warn(message, options) {
    toast(message, withOptions(options));
  },
};

export default appToast;
